import { z } from 'zod';

const COLLECTIONS = {
    Leads: 'leads',
    Institutions: 'institutions',
    InstitutionsSites: 'institutions_sites',
    InstitutionsSubscriptions: 'institutions_subscriptions',
    InstitutionsDirectusUsers: 'institutions_directus_users',
    SocialProfilesInstitutions: 'social_profiles_institutions',
    SocialProfiles: 'social_profiles',
    DirectusUsers: 'directus_users',
    Countries: 'countries',
    ArtAssets: 'art_assets',
    Agencies: 'agencies',
    ArtworkRequests: 'artwork_requests',
    Galleries: 'galleries',
    InstitutionsArtAssets: 'institutions_art_assets',
    Cities: 'cities',
    Contacts: 'contacts',
    ContactsInstitutions: 'contacts_institutions',
    Wallets: 'wallets',
    WalletsInstitutions: 'wallets_institutions',
    DirectusFiles: 'directus_files',
    ArtAssetsFiles: 'art_assets_files',
    StylesArtAssets: 'styles_art_assets',
    TagsArtAssets: 'tags_art_assets',
    Tags: 'tags',
    ArtistsArtAssets: 'artists_art_assets',
    Artists: 'artists',
    ArtistWalletAuthorizations: 'artist_wallet_authorizations',
    Medium: 'medium',
    MediumArtAssets: 'medium_art_assets',
    Styles: 'styles',
    InstitutionsArtists: 'institutions_artists',
    SaleOrder: 'sale_orders',
    SaleOrderShares: 'sale_order_shares',
    SalePlatformFees: 'sale_platform_fees',
    StorageFeeConfig: 'storage_fee_config',
    WalletsArtists: 'wallets_artists',
    DigitalOriginals: 'digital_originals',
    DocumentsArtists: 'documents_artists',
    FAQPages: 'faq_pages',
    SocialProfilesArtists: 'social_profiles_artists',
    ContactsArtists: 'contacts_artists',
    ArtistsGroupsIndividuals: 'artists_groups_individuals',
    SecondaryMarketRoyaltyConfig: 'secondary_market_royalty_config',
    ContactUs: 'contact_us',
    ShopReports: 'shop_reports',
    Subscriptions: 'subscriptions',
    Documents: 'documents',
    DocumentsInstitutions: 'documents_institutions',
    DocumentsArtAssets: 'documents_art_assets',
    DocumentsFiles: 'documents_files',
    ArtistsCountries: 'artists_countries',
    ArtistsStates: 'artists_states',
    ArtistsCities: 'artists_cities',
    GalleriesCountries: 'galleries_countries',
    GalleriesStates: 'galleries_states',
    GalleriesCities: 'galleries_cities',
    AgenciesCountries: 'agencies_countries',
    AgenciesStates: 'agencies_states',
    AgenciesCities: 'agencies_cities',
    CuratorsCountries: 'curators_countries',
    CuratorsStates: 'curators_states',
    CuratorsCities: 'curators_cities',
    CollectorsCountries: 'collectors_countries',
    CollectorsStates: 'collectors_states',
    CollectorsCities: 'collectors_cities',
    TokenHistory: 'token_history',
    IncomesHistory: 'incomes_history',
    Auctions: 'auctions',
    AuctionsBids: 'auction_bids',
    AuctionsShares: 'auction_shares',
    Currencies: 'currencies',
    ArtAssetsCountries: 'art_assets_countries',
    ArtAssetsStates: 'art_assets_states',
    ArtAssetsCities: 'art_assets_cities',
    DirectusActivity: 'directus_activity',
    DirectusRevisions: 'directus_revisions',
    UsersNotifications: 'users_notifications',
    AuctionFinishRequests: 'auction_finish_requests',
    AssetTransformations: 'asset_transformations',
    Collectors: 'collectors',
    Curators: 'curators',
    CuratorsReviews: 'curators_reviews',
    InstitutionsCurators: 'institutions_curators',
    Persons: 'persons',
    SocialProfilesPersons: 'social_profiles_persons',
    ArtistsWaitlist: 'artists_waitlist',
    News: 'news',
    NewsAuthors: 'news_authors',
    ContactsCurators: 'contacts_curators',
    ContactsCollectors: 'contacts_collectors',
    ContactsGalleries: 'contacts_galleries',
    ContactsAgencies: 'contacts_agencies',
    SocialProfilesCurators: 'social_profiles_curators',
    SocialProfilesCollectors: 'social_profiles_collectors',
    SocialProfilesGalleries: 'social_profiles_galleries',
    SocialProfilesAgencies: 'social_profiles_agencies',
    Selections: 'selections',
    SelectionsArtAssets: 'selections_art_assets',
    DigitalCommons: 'digital_commons',
};

const NotificationType = {
    ArtAssetDigitalOriginalAdded: 'ART_ASSET_DIGITAL_ORIGINAL_ADDED',
    ArtAssetVerified: 'ART_ASSET_VERIFIED',
    ArtAssetSoldWithDirectSale: 'ART_ASSET_SOLD_WITH_DIRECT_SALE',
    ArtAssetSoldWithAuction: 'ART_ASSET_SOLD_WITH_AUCTION',
    AuctionBidPlaced: 'AUCTION_BID_PLACED',
    AuctionExpired: 'AUCTION_EXPIRED',
    ArtistAddedWallet: 'ARTIST_ADDED_WALLET',
    ArtAssetPreOrderRequest: 'ART_ASSET_PRE_ORDER_REQUEST',
    ArtistWalletAuthorizationInvitationExpired: 'ARTIST_WALLET_AUTHORIZATION_INVITATION_EXPIRED',
};

const Feature = {
    AuthLayoutV2: 'ams_auth-v2',
    Colleagues: 'ams_colleagues',
    WizardButtonMock: 'ams_wizard_button_mock',
    ArtworkVerifyModal: 'ams_artwork_verify_modal',
    WalletRequiredForSaleStatus: 'wallet_required_for_sale_status',
    AmsNoData2: 'ams_no-data_v2',
    AmsFileUploadPanel: 'ams_file_upload_panel',
    BulkCreationOfArtAssets: 'bulk_creation_of_art_assets',
    TypedNavigation: 'typed_navigation',
    ArtistVerifyModal: 'ams_artist_verify_modal',
    Web3Manager: 'store_web3_manager',
    ZeroPercentSharesFilter: 'zero_percent_shares_filter',
    UfdaAuctionAnnounce: 'ufda_auctions_announce',
    UfdaLiveAuctions: 'ufda_live_auctions',
    CreateManuallyWallet: 'create_manually_wallet',
    UfdaViewerShadows: 'ufda_viewer_shadows',
    UfdaViewerHightlight: 'ufda_viewer_highlight',
    UfdaQuidget: 'ufda_quidget',
    UfdaViewerUseDpr: 'ufda_viewer_use_dpr',
    AmsViewerShadows: 'ams_viewer_shadows',
    AmsViewerHightlight: 'ams_viewer_highlight',
    AmsPhotographerSignUp: 'ams_photographer_sign_up',
    UfdaSentry: 'ufda_sentry_client',
    SuccessfulCreateSale: 'successful_create_sale',
    SuccessfulCreateAuction: 'successful_create_auction',
    AmsGoToCreateDirectSale: 'ams_go_to_create_direct_sale',
    AmsSelections: 'ams_selections',
    OnlyModifiedFormData: 'only_modified_form_data',
    PreventSaleDc: 'prevent_sale_dc',
    CaptchaEnabled: 'ams_captcha_enable',
    DisableArtistFee: 'ams_hide_artist_shares_input',
    FAQNewStructure: 'faq_new_structure',
};

const Env = {
    Local: 'local',
    Staging: 'staging',
    Production: 'production',
};

const MAX_LIMIT = 50;

const MIN_STRONG_PASSWORD_LENGTH = 12;
const PasswordRegexRule = {
    Uppercase: /[A-Z]/,
    Lowercase: /[a-z]/,
    Number: /[0-9]/,
    SpecialChar: /[!@#$%^&*()_+.,?:\-]+/,
    OnlyLatinLetters: /^[a-zA-Z0-9!@#$%^&*()_+.,?:\-]+$/,
    NoLeadingOrTrailSpace: /^\S.*\S$/,
};

const ViewsQueryType = { Daily: 'daily', Total: 'total', Multiple: 'multiple' };

const PREFIXES = {
    SHOP_API: 'shop-api',
    AMS_API: 'ams-api',
    ON_CHAIN_HISTORY: 'on-chain-history',
};
const withPrefix = (prefix) => (channel) => `${prefix}:${channel}`;
const SHOP_API = withPrefix(PREFIXES.SHOP_API);
const AMS_API = withPrefix(PREFIXES.AMS_API);
const ON_CHAIN_HISTORY = withPrefix(PREFIXES.ON_CHAIN_HISTORY);
const CHANNELS = {
    ANALYTICS: {
        TRACK_BID_SESSION: SHOP_API('analytics:track-bid-session'),
        GA4_REQUESTS: AMS_API('analytics:ga4-requests'),
    },
    TRANSACTIONS: {
        STATUS_UPDATE: ON_CHAIN_HISTORY('transaction-status-update'),
    },
};

const BIG_IMAGE_TYPES = { DigitalOriginal: 'digital_original', DigitalCommon: 'digital_common' };

const photoSchema = z.object({
    id: z.string(),
    type: z.string().nullable().optional(),
    width: z.number().nullable().optional(),
    height: z.number().nullable().optional(),
    title: z.string().nullable().optional(),
    filename_disk: z.string().nullable(),
    filesize: z.coerce.number().nullable().optional(),
    asset_transformations: z
        .object({
        preset_key: z.string(),
        transformation_name: z.string(),
    })
        .array()
        .nullable()
        .optional(),
});
const dngSchema = z.object({
    id: z.string(),
    type: z.string().nullable(),
    width: z.number().nullable(),
    height: z.number().nullable(),
    title: z.string().nullable(),
    filesize: z.coerce.number().nullable(),
});

const paragraphSchema = z.object({
    text: z.string(),
});
const nestedListSchema = z.object({
    style: z.enum(['unordered', 'ordered']),
    items: z.array(z.object({
        content: z.string(),
        items: z.array(z.unknown()),
    })),
});
const headerSchema = z.object({
    text: z.string(),
    level: z.number().optional(),
});
const quoteSchema = z.object({
    text: z.string(),
    caption: z.string(),
    alignment: z.enum(['left', 'center']),
});
const codeSchema = z.object({
    code: z.string(),
});
const checkListSchema = z.object({
    items: z.array(z.object({
        text: z.string(),
        checked: z.boolean(),
    })),
});
const imageSchema = z.object({
    file: photoSchema,
    caption: z.string(),
    withBorder: z.boolean(),
    stretched: z.boolean(),
    withBackground: z.boolean(),
});
const embedSchema = z.object({
    service: z.string(),
    source: z.string().url(),
    embed: z.string().url(),
    width: z.number(),
    height: z.number(),
    caption: z.string(),
});
const delimiterSchema = z.object({});
const blockSchema = z
    .object({
    id: z.string(),
})
    .and(z.discriminatedUnion('type', [
    z.object({
        type: z.literal('header'),
        data: headerSchema,
    }),
    z.object({
        type: z.literal('paragraph'),
        data: paragraphSchema,
    }),
    z.object({
        type: z.enum(['nestedlist', 'list']),
        data: nestedListSchema,
    }),
    z.object({
        type: z.literal('quote'),
        data: quoteSchema,
    }),
    z.object({
        type: z.literal('code'),
        data: codeSchema,
    }),
    z.object({
        type: z.literal('checklist'),
        data: checkListSchema,
    }),
    z.object({
        type: z.literal('image'),
        data: imageSchema,
    }),
    z.object({
        type: z.literal('embed'),
        data: embedSchema,
    }),
    z.object({
        type: z.literal('delimiter'),
        data: delimiterSchema,
    }),
]));
const editorBlockSchema = z.object({
    time: z.number(),
    blocks: z.array(blockSchema),
    version: z.string(),
});

const Gender = {
    Male: 'male',
    Female: 'female',
    Other: 'other',
};

const placeSchema = z.object({
    id: z.number(),
    value: z.string(),
});
const locationSchema = z.object({
    country: placeSchema,
    state: placeSchema.optional().nullable(),
    city: placeSchema.optional().nullable(),
    address: z.string().optional().nullable(),
});

const urisSchema = z
    .object({
    metadata: z.string().url(),
    image: z.string().url(),
    digital_original: z.string().url(),
})
    .or(z.object({}));

const Status = {
    Draft: 'draft',
    Published: 'published',
    Archived: 'archived',
    Unlisted: 'unlisted',
};
const directusItemStatusSchema = z.nativeEnum(Status);

const optionSchema = z.object({
    id: z.number(),
    slug: z.string(),
    name: z.string(),
});

const dateSchema = z.union([z.string(), z.date()]);

const emailSchema = z
    .string()
    .trim()
    .min(1, 'Email is required')
    .email({ message: 'Please enter a valid email address' });
const strongPasswordSchema = z
    .string()
    .min(MIN_STRONG_PASSWORD_LENGTH, `Password must be at least ${MIN_STRONG_PASSWORD_LENGTH} characters`)
    .regex(PasswordRegexRule.Uppercase, 'Password must contain at least one uppercase letter')
    .regex(PasswordRegexRule.Lowercase, 'Password must contain at least one lowercase letter')
    .regex(PasswordRegexRule.Number, 'Password must contain at least one number')
    .regex(PasswordRegexRule.SpecialChar, 'Password must contain at least one special character')
    .regex(PasswordRegexRule.OnlyLatinLetters, 'Password must not contain non-Latin letters')
    .regex(PasswordRegexRule.NoLeadingOrTrailSpace, 'Password must not contain leading or trailing spaces');
const passwordSchema = z.string().trim().min(1, 'Password is required');

const SizeUnit = {
    Inch: 'inch',
    Cm: 'cm',
};
const originalSizeSchema = z.object({
    original_units: z.nativeEnum(SizeUnit, { required_error: 'unit is required in art asset' }),
    original_size_x: z.string({ required_error: 'original_size_x is required in art asset' }),
    original_size_y: z.string({ required_error: 'original_size_y is required in art asset' }),
});

const Blockchain = {
    Ethereum: 'ethereum',
};

const ContactType = {
    Phone: 'phone',
    Email: 'email',
};
const contactsSchema = z.object({
    id: z.number(),
    type: z.nativeEnum(ContactType),
    value: z.string(),
});

const SocialProfileType = {
    Site: 'site',
    Instagram: 'instagram',
    Facebook: 'facebook',
    X: 'x',
    LinkedIn: 'linkedin',
    Telegram: 'telegram',
    WhatsApp: 'whatsapp',
};
const socialProfileSchema = z.object({
    id: z.number(),
    type: z.nativeEnum(SocialProfileType),
    value: z.string(),
    date_created: z.string(),
    date_updated: z.string().nullable(),
    user_created: z.string(),
    user_updated: z.string().nullable(),
});

const agencySchema = z.object({
    id: z.number(),
    slug: z.string().nullable(),
    name: z.string(),
    contacts: contactsSchema.array().nullable(),
    social_profiles: socialProfileSchema.array().nullable(),
    countries: z.object({ id: z.number() }).array().nullable(),
    states: z.object({ id: z.number() }).array().nullable(),
    cities: z.object({ id: z.number() }).array().nullable(),
    associated_institutions: z.array(z.number()).nullable(),
    user_created: z.string(),
    user_updated: z.string().nullable(),
    date_created: z.string(),
    date_updated: z.string().nullable(),
});

const ArtAssetType = {
    DigitalCommon: 'digital_common',
    DigitalOriginal: 'digital_original',
};
const ArtAssetFormat = {
    Image: 'image',
    '3Dobject': '3d_object',
    MotionArt: 'motion_art',
    Json: 'json',
};
const ArtAssetContentFlags = {
    NSFW: 'nsfw',
    FlashingHazards: 'flashing_hazards',
};
const TokenStatus = {
    Draft: 'draft',
    ReadyForVerification: 'ready_for_verification',
    OnVerification: 'on_verification',
    OnDigitalization: 'on_digitalization',
    ReadyForSale: 'ready_for_sale',
    OnSale: 'on_sale',
    OnDraftAuction: 'on_draft_auction',
    OnAuction: 'on_auction',
    Sold: 'sold',
};
const SaleStatus = {
    OffSale: 'off_sale',
    Sold: 'sold',
    OnSale: 'on_sale',
    Realized: 'realized',
    PlacingOrderFailed: 'placing_order_failed',
};
const saleDataSchema = z.object({
    price: z.string(),
    participants: z.array(z.object({
        address: z.string(),
        share: z.string(),
    })),
});
const exifMetadataSchema = z.object({
    FileType: z.string({
        required_error: 'FileType is required in digital original exif',
        invalid_type_error: 'FileType in digital original exif must be a string',
    }),
    FileSize: z.string({
        required_error: 'FileSize is required in digital original exif',
        invalid_type_error: 'FileSize in digital original exif must be a string',
    }),
    CreateDate: z.string({
        required_error: 'CreateDate is required in digital original exif',
        invalid_type_error: 'CreateDate in digital original exif must be a string',
    }),
    ImageWidth: z.number({
        required_error: 'ImageWidth is required in digital original exif',
        invalid_type_error: 'ImageWidth in digital original exif must be a number',
    }),
    ImageHeight: z.number({
        required_error: 'ImageHeight is required in digital original exif',
        invalid_type_error: 'ImageHeight must be a number in digital original exif',
    }),
    Make: z.string({
        required_error: 'Make is required in digital original exif',
        invalid_type_error: 'Make must be a string in digital original exif',
    }),
    Model: z.string({
        required_error: 'Model in digital original exif is required',
        invalid_type_error: 'Model must be a string in digital original exif',
    }),
    LensMake: z.string({
        required_error: 'LensMake is required in digital original exif',
        invalid_type_error: 'LensMake in digital original exif must be a string',
    }),
    LensModel: z.string({
        required_error: 'LensModel is required in digital original exif',
        invalid_type_error: 'LensModel in digital original exif must be a string',
    }),
    ColorSpace: z.string({
        required_error: 'ColorSpace is required in digital original exif',
        invalid_type_error: 'ColorSpace in digital original exif must be a string',
    }),
    FocalLength: z.string({
        required_error: 'FocalLength is required in digital original exif',
        invalid_type_error: 'FocalLength in digital original exif must be a string',
    }),
    MeteringMode: z.string({
        required_error: 'MeteringMode is required in digital original exif',
        invalid_type_error: 'MeteringMode in digital original exif must be a string',
    }),
    FNumber: z.number({
        required_error: 'FNumber is required in digital original exif',
        invalid_type_error: 'FNumber must be a number',
    }),
    ExposureProgram: z.string({
        required_error: 'ExposureProgram is required in digital original exif',
        invalid_type_error: 'ExposureProgram in digital original exif must be a string',
    }),
    ExposureTime: z.union([z.number(), z.string()], {
        required_error: 'ExposureTime is required in digital original exif',
        invalid_type_error: 'ExposureTime in digital original exif must be a string or number',
    }),
});
const uploadDOMetadataRequestSchema = z.object({
    name: z.string({ required_error: 'name_english is required in art asset' }),
    image: z.string({ required_error: 'file_id is required in digital original' }).url(),
    description: z.string().optional(),
    provenance: z.string().optional(),
    creating_years: z.string({ required_error: 'creating_years is required in art asset' }),
    artists: z.array(z.string()).min(1, { message: 'artists are required' }),
    art_medium: z.array(z.string()).min(1, { message: 'medium is required in art asset' }),
    art_styles: z.array(z.string()).min(1, { message: 'style is required in art asset' }),
    original_sizes: z.object({
        unit: z.enum(['inch', 'cm'], {
            required_error: 'unit is required in art asset',
            invalid_type_error: 'unit in art asset must be a string',
        }),
        x: z.string({
            required_error: 'original_size_x is required in art asset',
            invalid_type_error: 'original_size_x in art asset must be a string',
        }),
        y: z.string({
            required_error: 'original_size_y is required in art asset',
            invalid_type_error: 'original_size_y in art asset must be a string',
        }),
        z: z.string().optional().nullable(),
    }),
    digital_original: z
        .string({
        required_error: 'digital_original is required in art asset',
        invalid_type_error: 'digital_original link must be a string',
    })
        .url({ message: 'digital_original link must be a valid URL' }),
    digital_original_metadata: z.object({
        mpx: z
            .number({
            required_error: 'mpx is required in digital original',
            invalid_type_error: 'mpx in digital original must be a number',
        })
            .positive(),
        dimensions: z.string({
            required_error: 'dimensions(ImageWidth, ImageHeight) are required in digital original',
            invalid_type_error: 'dimensions(ImageWidth, ImageHeight) in digital original must be a string',
        }),
        color_profile_description: z.string({
            required_error: 'color_profile_description is required in digital original',
            invalid_type_error: 'color_profile_description in digital original must be a string',
        }),
        exif: exifMetadataSchema,
    }),
});
const uploadDCMetadataRequestSchema = z.object({
    name: z.string({ required_error: 'name_english is required in art asset' }),
    image: z.string({ required_error: 'file_id is required in digital original' }).url(),
    digital_common: z.string({ required_error: 'main_image is required in art asset' }).url(),
    description: z.string().optional(),
    provenance: z.string().optional(),
    creating_years: z.string({ required_error: 'creating_years is required in art asset' }),
    artists: z.array(z.string()).min(1, { message: 'artists are required' }),
    art_medium: z.array(z.string()).min(1, { message: 'medium is required in art asset' }),
    art_styles: z.array(z.string()).min(1, { message: 'style is required in art asset' }),
    original_sizes: z
        .object({
        unit: z.enum(['inch', 'cm'], {
            required_error: 'unit is required in art asset',
            invalid_type_error: 'unit in art asset must be a string',
        }),
        x: z.string({
            required_error: 'original_size_x is required in art asset',
            invalid_type_error: 'original_size_x in art asset must be a string',
        }),
        y: z.string({
            required_error: 'original_size_y is required in art asset',
            invalid_type_error: 'original_size_y in art asset must be a string',
        }),
        z: z.string().optional().nullable(),
    })
        .optional(),
    source_file: z
        .string({
        required_error: 'source_file is required in art assets digital common',
        invalid_type_error: 'source_file is required in art assets digital common',
    })
        .url({ message: 'source_file link must be a valid URL' }),
    digital_common_metadata: z.object({
        mpx: z
            .number({
            invalid_type_error: 'mpx in digital common must be a number',
        })
            .positive()
            .optional(),
        dimensions: z
            .string({
            invalid_type_error: 'dimensions(ImageWidth, ImageHeight) in digital common must be a string',
        })
            .optional(),
        color_profile_description: z
            .string({
            invalid_type_error: 'color_profile_description in digital common must be a string',
        })
            .optional(),
        exif: exifMetadataSchema.partial(),
    }),
});
const predictDOImagesCIDRequestSchema = z.object({
    image: z.string({ required_error: 'file_id is required in digital original' }).url(),
    digital_original: z
        .string({
        required_error: 'digital_original is required in art asset',
        invalid_type_error: 'digital_original link must be a string',
    })
        .url({ message: 'digital_original link must be a valid URL' }),
});
const predictDCImagesCIDRequestSchema = z.object({
    image: z.string({ required_error: 'file_id is required in digital original' }).url(),
    digital_common: z
        .string({
        required_error: 'main_photo is required in art asset',
        invalid_type_error: 'digital_common link must be a string',
    })
        .url({ message: 'digital_common link must be a valid URL' }),
    source_file: z
        .string({
        required_error: 'source_file is required in art assets digital common',
        invalid_type_error: 'source_file is required in art assets digital common',
    })
        .url({ message: 'source_file link must be a valid URL' }),
});

const ArtworkRequestStatus = {
    New: 'new',
    Read: 'read',
};

const ArtistStatus = {
    Published: 'published',
    Unpublished: 'unpublished',
    Draft: 'draft',
};
const ArtistVerificationStatus = {
    Draft: 'draft',
    ReadyForVerification: 'ready_for_verification',
    AwaitingForVerification: 'awaiting_for_verification',
    Verified: 'verified',
    Rejected: 'rejected',
};
const ArtistType = {
    Individual: 'individual',
    Group: 'group',
};
const artistSchema = z.object({
    id: z.number(),
    status: z.nativeEnum(ArtistStatus),
    name: z.string(),
    name_aliases: z.string().nullable(),
    name_transliteration: z.string(),
    pseudonym: z.string().nullable(),
    gender: z.nativeEnum(Gender),
    birth_year: z.number().nullable(),
    date_of_birth: z.string().nullable(),
    date_of_death: z.string().nullable(),
    alive: z.boolean(),
    photo: photoSchema.nullable(),
    photo_attribution: z.string().nullable(),
    slug: z.string().nullable(),
    biography: editorBlockSchema.nullable(),
    relationship_information: editorBlockSchema.nullable(),
    verified: z.boolean(),
    verification_status: z.nativeEnum(ArtistVerificationStatus),
    wallets: z
        .array(z.object({
        wallets_id: z.object({
            id: z.string(),
            address: z.string(),
            verified: z.boolean(),
            suspended: z.boolean(),
        }),
    }))
        .nullable(),
    associated_institutions: z.array(z.number()).nullable(),
    date_created: z.string(),
    date_updated: z.string().nullable(),
});

const ArtistWalletAuthorizationsStatus = {
    Pending: 'pending',
    SendingFailed: 'sending_failed',
    Visited: 'visited',
    Authorized: 'authorized',
    Unauthorized: 'unauthorized',
    Expired: 'expired',
    Closed: 'closed',
};

const AuctionStatus = {
    Draft: 'draft',
    Pending: 'pending',
    Active: 'active',
    Finalizing: 'finalizing',
    Sold: 'sold',
    Canceled: 'canceled',
    Expired: 'expired',
};

const classificationItemSchema = z.object({
    id: z.number(),
    slug: z.string(),
    name: z.string(),
});
const styleSchema = classificationItemSchema.merge(z.object({
    institution_id: z.number().nullable(),
}));
const mediumSchema = classificationItemSchema.merge(z.object({
    institution_id: z.number().nullable(),
}));

const ContactUsType = {
    Gallery: 'gallery',
    Artist: 'artist',
    Collector: 'collector',
    Curator: 'curator',
    Investor: 'investor',
    Partner: 'partner',
    Other: 'other',
};
const ContactUsInquiryType = {
    GeneralIssue: 'general_questions',
    LegalIssue: 'legal_issue',
    TechnicalIssues: 'technical_issues',
    RequestOrSuggestAFeature: 'request_or_suggest_a_feature',
    DLCTGuidelineAndLicensing: 'dlct_guideline_and_licensing',
    PaymentIssue: 'payment_issue',
    PartnershipAndCooperation: 'partnership_and_cooperation',
};
const ContactUsFrom = {
    Shop: 'shop',
    DOS: 'dos',
    Store: 'store',
    Platform: 'platform',
    Landing: 'landing',
    NewEraLanding: 'new-era-landing',
    Blockchain101: 'blockchain_101',
    PlatformLanding: 'platform_landing',
    UFDA: 'ufda',
    WebinarRegistration1: 'webinar_registration_1',
    WebinarRegistration2: 'webinar_registration_2',
    WebinarRegistration3: 'webinar_registration_3',
    WebinarWatch1: 'webinar_watch_1',
    WebinarWatch2: 'webinar_watch_2',
    WebinarWatch3: 'webinar_watch_3',
};
const contactUsSchema = z.object({
    id: z.number(),
    from: z.nativeEnum(ContactUsFrom),
    captured_url: z.string().nullable().optional(),
    full_name: z.string(),
    email: z.string().email(),
    phone: z.string().nullable().optional(),
    major: z.string().nullable().optional(),
    country: z.number().nullable().optional(),
    gallery_name: z.string().nullable().optional(),
    type: z.nativeEnum(ContactUsType).default(ContactUsType.Other),
    inquiry_type: z.nativeEnum(ContactUsInquiryType).nullable().optional(),
    message: z.string().nullable().optional(),
    date_created: z.string(),
});

const collectorSchema = z.object({
    id: z.number(),
    slug: z.string(),
    first_name: z.string(),
    last_name: z.string().nullable(),
    nickname: z.string().nullable(),
    photo: photoSchema.nullable(),
    photo_attribution: z.string().nullable(),
    date_of_birth: z.string().nullable(),
    gender: z.nativeEnum(Gender).nullable(),
    biography: editorBlockSchema.nullable(),
    contacts: contactsSchema.array().nullable(),
    social_profiles: socialProfileSchema.array().nullable(),
    countries: z.object({ id: z.number() }).array().nullable(),
    states: z.object({ id: z.number() }).array().nullable(),
    cities: z.object({ id: z.number() }).array().nullable(),
    associated_institutions: z.array(z.number()).nullable(),
    user_created: z.string(),
    user_updated: z.string().nullable(),
    date_created: z.string(),
    date_updated: z.string().nullable(),
});

const exifSchema = z
    .object({
    FileType: z.string(),
    FileSize: z.string(),
    CreateDate: z.string(),
    ImageWidth: z.number(),
    ImageHeight: z.number(),
    Make: z.string(),
    Model: z.string(),
    LensMake: z.string(),
    LensModel: z.string(),
    ColorSpace: z.string(),
    FocalLength: z.string(),
    MeteringMode: z.string(),
    FNumber: z.number(),
    ExposureProgram: z.string(),
    ExposureTime: z.union([z.number(), z.string()]),
    Photographer: z.string(),
})
    .partial();
const digitalOriginalSchema = z.object({
    id: z.number(),
    color_profile_description: z.string(),
    color_space: z.string().optional().nullable(),
    created: z.string().optional().nullable(),
    date_created: z.string(),
    date_updated: z.string().nullable(),
    device_make: z.string().optional().nullable(),
    device_model: z.string().optional().nullable(),
    exprosure_program: z.string().optional().nullable(),
    exprosure_time: z.string().optional().nullable(),
    f_number: z.string().optional().nullable(),
    file_id: z.string(),
    focal_length: z.string().optional().nullable(),
    format: z.string().optional().nullable(),
    lense_make: z.string().optional().nullable(),
    lense_model: z.string().optional().nullable(),
    metering_mode: z.string().optional().nullable(),
    mpx: z.number(),
    size: z.string().nullable(),
    user_created: z.string(),
    user_updated: z.string().nullable(),
    height: z.string().optional().nullable(),
    width: z.string().nullable().optional(),
    exif: exifSchema.nullable(),
    photographer: z.object({ id: z.string(), first_name: z.string(), last_name: z.string() }).or(z.number()).nullable(),
    dng: z.string().or(dngSchema).nullable(),
});

const digitalCommonSchema = z.object({
    id: z.number(),
    file: z.string().nullable(),
    preview: z.string().nullable(),
    date_created: z.string(),
    user_created: z.string(),
    date_updated: z.string().nullable(),
    user_updated: z.string().nullable(),
});

const documentSchema = z.object({
    id: z.number(),
    name: z.string(),
    slug: z.string().nullable(),
    subtype: z.string().nullable(),
    type: z.string(),
});
const DocumentType = {
    DigitalOriginalPurchase: 'digital_original_purchase',
    PhysicalOriginalPurchase: 'physical_original_purchase',
    PhysicalAndDigitalOriginalPurchase: 'physical_and_digital_original_purchase',
    AgreementWithArtist: 'agreement_with_artist',
    DLCTServiceAgreement: 'dlct_service_agreement',
    Other: 'other',
};
const DocumentSubtype = {
    Agreement: 'agreement',
    AdditionalAgreement: 'additional_agreement',
    Act: 'act',
    Other: 'other',
};

const gallerySchema = z.object({
    id: z.number(),
    slug: z.string().nullable(),
    name: z.string(),
    contacts: contactsSchema.array().nullable(),
    social_profiles: socialProfileSchema.array().nullable(),
    countries: z.object({ id: z.number() }).array().nullable(),
    states: z.object({ id: z.number() }).array().nullable(),
    cities: z.object({ id: z.number() }).array().nullable(),
    associated_institutions: z.array(z.number()).nullable(),
    user_created: z.string(),
    user_updated: z.string().nullable(),
    date_created: z.string(),
    date_updated: z.string().nullable(),
});

const FAQPageSchema = z.object({
    date_created: z.string(),
    date_updated: z.string().nullable(),
    categories: z.array(z.object({
        id: z.number(),
        name: z.string(),
        faq_blocks: z.array(z.object({
            id: z.number(),
            question: z.string(),
            answer: editorBlockSchema.nullable(),
        })),
    })),
    faq_categories: z.array(z.object({
        faq_categories_id: z.object({
            id: z.number(),
            name: z.string(),
            blocks: z.array(z.object({
                faq_blocks_id: z.object({
                    id: z.number(),
                    question: z.string(),
                    answer: editorBlockSchema.nullable(),
                }),
            })),
        }),
    })),
});

const curatorSchema = z.object({
    id: z.number(),
    slug: z.string(),
    first_name: z.string(),
    last_name: z.string().nullable(),
    nickname: z.string().nullable(),
    photo: photoSchema.nullable(),
    photo_attribution: z.string().nullable(),
    date_of_birth: z.string().nullable(),
    gender: z.nativeEnum(Gender).nullable(),
    biography: editorBlockSchema.nullable(),
    position: z.string().nullable().optional(),
    contacts: contactsSchema.array().nullable(),
    social_profiles: socialProfileSchema.array().nullable(),
    countries: z.object({ id: z.number() }).array().nullable(),
    states: z.object({ id: z.number() }).array().nullable(),
    cities: z.object({ id: z.number() }).array().nullable(),
    associated_institutions: z.array(z.number()).nullable(),
    date_created: z.string(),
    date_updated: z.string().nullable(),
    user_created: z.string(),
    user_updated: z.string().nullable(),
});

const InviteStatus = {
    New: 'new',
    Invited: 'invited',
    Active: 'active',
    Reject: 'reject',
};
const InstitutionVerificationStatus = {
    Unverified: 'unverified',
    Verified: 'verified',
    Restricted: 'restricted',
};
const InstitutionType = {
    Artist: 'artist',
    Gallery: 'gallery',
    Collector: 'collector',
    Curator: 'curator',
    Agency: 'agency',
    Photographer: 'photographer',
};
const institutionSchema = z.object({
    id: z.number(),
    name: z.string(),
    slug: z.string().nullable(),
    slug_approved: z.boolean(),
    status: z.nativeEnum(Status),
    invite_status: z.nativeEnum(InviteStatus),
    verification_status: z.nativeEnum(InstitutionVerificationStatus),
    restriction_reason: z.string().nullable(),
    type: z.nativeEnum(InstitutionType),
    company_number: z.string().nullable(),
    logo: photoSchema.nullable(),
    description: editorBlockSchema.nullable(),
    wizard_finished: z.boolean(),
    is_suspicious: z.boolean(),
    associated_artist: z.union([z.number(), artistSchema]).nullable(),
    associated_gallery: z.union([z.number(), gallerySchema]).nullable(),
    associated_collector: z.union([z.number(), collectorSchema]).nullable(),
    associated_curator: z.union([z.number(), curatorSchema]).nullable(),
    associated_agency: z.union([z.number(), agencySchema]).nullable(),
});

const SiteStatus = {
    Draft: 'draft',
    PreRelease: 'pre_release',
    Published: 'published',
};

const LeadFrom = {
    Landing: 'do-landing',
    Blockchain101: 'blockchain_101',
    DoPlatformLanding: 'do-platform-landing',
};
const LeadType = {
    Gallery: 'gallery',
    Artist: 'artist',
    Collector: 'collector',
    Curator: 'curator',
    Investor: 'investor',
    Partner: 'partner',
    Other: 'other',
};
const leadSchema = z.object({
    id: z.number(),
    from: z.nativeEnum(LeadFrom),
    type: z.nativeEnum(LeadType),
    full_name: z.string(),
    gallery_name: z.string().optional(),
    phone: z.string().optional(),
    email: z.string().email(),
    send_blockchain_handbook: z.boolean(),
});

const ReportedCollection = {
    ArtAsset: 'art_asset',
    Artist: 'artist',
    Auction: 'auction',
};
const ReportType = {
    GeneralIssue: 'general_issue',
    LegalIssue: 'legal_issue',
    TechnicalProblem: 'technical_problem',
};
const shopReportSchema = z.object({
    type: z.nativeEnum(ReportType),
    message: z.string(),
    full_name: z.string(),
    email: z.string().email(),
    url: z.string().url(),
    reported_collection: z.nativeEnum(ReportedCollection),
    [ReportedCollection.ArtAsset]: z.number().optional(),
    [ReportedCollection.Artist]: z.number().optional(),
    date_created: z.string(),
    date_updated: z.string().nullable(),
});

const SubscriptionFrom = {
    Landing: 'do-landing',
    TheNakedRoom: 'the-naked-room',
    DOS: 'dos',
    Shop: 'shop',
    Store: 'store',
};
const subscriptionsSchema = z.object({
    id: z.number(),
    from: z.nativeEnum(SubscriptionFrom),
    email: z.string().email(),
    date_created: z.string(),
});

const UserStatus = {
    Active: 'active',
    Draft: 'draft',
    Suspended: 'suspended',
    Archived: 'archived',
    Invited: 'invited',
};

const userNotificationSchema = z.object({
    collection: z.string(),
    date_created: z.coerce.date(),
    date_updated: z.coerce.date().nullable(),
    id: z.number(),
    institutions_directus_user: z.number(),
    viewed: z.boolean(),
    type: z.string(),
    payload: z.record(z.any()),
    item: z.string(),
});

const InstitutionUserRole = {
    InstitutionAdmin: 'institution_admin',
    InstitutionManager: 'institution_manager',
};
const InstitutionUserStatus = {
    Active: 'active',
    Restricted: 'restricted',
};

const ColleagueStatus = {
    Invited: 'invited',
    Active: 'active',
    Draft: 'draft',
    Suspended: 'suspended',
    Archived: 'archived',
};
const ColleagueRole = {
    Admin: 'institution_admin',
    Manager: 'institution_manager',
};

const ArtistsWaitlistItemStatus = {
    Pending: 'pending',
    Approved: 'approved',
    Rejected: 'rejected',
};

const NewsPublicationTarget = {
    UFDA: 'UFDA',
    Landing: 'landing',
};

const SelectionStatus = {
    Draft: 'draft',
    Public: 'public',
    Restricted: 'restricted',
    Unlisted: 'unlisted',
};

var SaleOrderStatus;
(function (SaleOrderStatus) {
    SaleOrderStatus["Placed"] = "placed";
    SaleOrderStatus["Realized"] = "realized";
    SaleOrderStatus["Canceled"] = "canceled";
})(SaleOrderStatus || (SaleOrderStatus = {}));

var TokenHistoryRecordKind;
(function (TokenHistoryRecordKind) {
    TokenHistoryRecordKind["Transfer"] = "transfer";
    TokenHistoryRecordKind["Mint"] = "mint";
    TokenHistoryRecordKind["Buy"] = "buy";
    TokenHistoryRecordKind["AuctionCreated"] = "auction_created";
    TokenHistoryRecordKind["AuctionBidPlaced"] = "auction_bid_placed";
    TokenHistoryRecordKind["AuctionSold"] = "auction_sold";
    TokenHistoryRecordKind["MarketPlaced"] = "market_placed";
    TokenHistoryRecordKind["MarketRealized"] = "market_realized";
    TokenHistoryRecordKind["MarketCancelled"] = "market_cancelled";
})(TokenHistoryRecordKind || (TokenHistoryRecordKind = {}));

const DirectusFileTagsType = {
    ArtAsset: 'art_asset',
    Artist: 'artist',
    Document: 'document',
    InstitutionLogo: 'institution_logo',
    SiteFavicon: 'site_favicon',
    DigitalCommon: 'digital_common',
};
const directusFileSchema = z.object({
    id: z.string(),
    storage: z.string(),
    filename_disk: z.string(),
    filename_download: z.string(),
    title: z.string().nullable(),
    type: z.string(),
    folder: z.string().nullable(),
    uploaded_by: z.string().nullable(),
    uploaded_on: z.string(),
    modified_by: z.string().nullable(),
    modified_on: z.string().nullable(),
    charset: z.string().nullable(),
    filesize: z.coerce.number(),
    width: z.number().nullable(),
    height: z.number().nullable(),
    duration: z.number().nullable(),
    embed: z.string().nullable(),
    description: z.string().nullable(),
    location: z.string().nullable(),
    tags: z.array(z.string()).nullable(),
    metadata: z.record(z.any()).nullable(),
});

const DirectusRoleNames = {
    CRMAdmin: '[CRM_USER]: institution_admin',
    Administrator: 'Administrator',
};

const artistIsReadyForVerificationSchema = z.object({
    name: z.string().min(2).max(100),
    name_transliteration: z.string().min(2).max(100),
    contacts: z
        .array(z.discriminatedUnion('type', [
        z.object({
            type: z.literal(ContactType.Phone),
            value: z
                .string()
                .trim()
                .regex(/^$|^\+(?!\s{2,})[\d\s]+$/, 'Please enter a valid phone'),
        }),
        z.object({
            type: z.literal(ContactType.Email),
            value: z.string().trim().email(),
        }),
    ]))
        .length(2),
});
const artistIsPublishableSchema = artistIsReadyForVerificationSchema.and(z.object({
    verification_status: z.literal(ArtistVerificationStatus.Verified),
}));

const immutableTokenStatuses = [
    TokenStatus.OnSale,
    TokenStatus.OnAuction,
    TokenStatus.Sold,
    TokenStatus.OnDraftAuction,
];
const MIN_DN_PRICE_USD = 40;

export { ArtAssetContentFlags, ArtAssetFormat, ArtAssetType, ArtistStatus, ArtistType, ArtistVerificationStatus, ArtistWalletAuthorizationsStatus, ArtistsWaitlistItemStatus, ArtworkRequestStatus, AuctionStatus, BIG_IMAGE_TYPES, Blockchain, CHANNELS, COLLECTIONS, ColleagueRole, ColleagueStatus, ContactType, ContactUsFrom, ContactUsInquiryType, ContactUsType, DirectusFileTagsType, DirectusRoleNames, DocumentSubtype, DocumentType, Env, FAQPageSchema, Feature, Gender, InstitutionType, InstitutionUserRole, InstitutionUserStatus, InstitutionVerificationStatus, InviteStatus, LeadFrom, LeadType, MAX_LIMIT, MIN_DN_PRICE_USD, MIN_STRONG_PASSWORD_LENGTH, NewsPublicationTarget, NotificationType, PasswordRegexRule, ReportType, ReportedCollection, SaleOrderStatus, SaleStatus, SelectionStatus, SiteStatus, SizeUnit, SocialProfileType, Status, SubscriptionFrom, TokenHistoryRecordKind, TokenStatus, UserStatus, ViewsQueryType, agencySchema, artistIsPublishableSchema, artistIsReadyForVerificationSchema, artistSchema, blockSchema, checkListSchema, classificationItemSchema, codeSchema, collectorSchema, contactUsSchema, contactsSchema, curatorSchema, dateSchema, delimiterSchema, digitalCommonSchema, digitalOriginalSchema, directusFileSchema, directusItemStatusSchema, dngSchema, documentSchema, editorBlockSchema, emailSchema, embedSchema, exifMetadataSchema, exifSchema, gallerySchema, headerSchema, imageSchema, immutableTokenStatuses, institutionSchema, leadSchema, locationSchema, mediumSchema, nestedListSchema, optionSchema, originalSizeSchema, paragraphSchema, passwordSchema, photoSchema, placeSchema, predictDCImagesCIDRequestSchema, predictDOImagesCIDRequestSchema, quoteSchema, saleDataSchema, shopReportSchema, socialProfileSchema, strongPasswordSchema, styleSchema, subscriptionsSchema, uploadDCMetadataRequestSchema, uploadDOMetadataRequestSchema, urisSchema, userNotificationSchema };
